/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { FixLineItemRequestDTO } from "../model";
import {
  FixLineItemRequestDTOTrackedI,
  FixLineItemRequestDTOMeta,
} from "../model";
// @ts-ignore
import type { FixLineItemResponseDTO } from "../model";
import {
  FixLineItemResponseDTOTrackedI,
  FixLineItemResponseDTOMeta,
} from "../model";
// @ts-ignore
import type { OrderDTO } from "../model";
import { OrderDTOTrackedI, OrderDTOMeta } from "../model";
// @ts-ignore
import type { OrderStateNew } from "../model";
import { OrderStateNewTrackedI, OrderStateNewMeta } from "../model";
// @ts-ignore
import type { OrderWithDiscountsDTO } from "../model";
import {
  OrderWithDiscountsDTOTrackedI,
  OrderWithDiscountsDTOMeta,
} from "../model";
// @ts-ignore
import type { PersonAgreementsDTO } from "../model";
import { PersonAgreementsDTOTrackedI, PersonAgreementsDTOMeta } from "../model";
// @ts-ignore
import type { PrintOrderReceiptDTO } from "../model";
import {
  PrintOrderReceiptDTOTrackedI,
  PrintOrderReceiptDTOMeta,
} from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * CompassOrderApi - axios parameter creator
 * @export
 */
export const CompassOrderApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Returns the current order this person has open
     * @param {number} id The order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderIdGet: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("memberCompassOrderIdGet", "id", id);
      const localVarPath = `/member/compass-order/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns the current order this person has open
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderOpenGet: (
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/member/compass-order/open`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates or inserts order and subobjects into the database for further use in the order system
     * @param {OrderDTO} orderDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderPost: (
      orderDTO: OrderDTOTrackedI,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'orderDTO' is not null or undefined
      assertParamExists("memberCompassOrderPost", "orderDTO", orderDTO);
      const localVarPath = `/member/compass-order`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        orderDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns an order with calculated values without creating anything in the database
     * @param {OrderDTO} orderDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderProtoPost: (
      orderDTO: OrderDTOTrackedI,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'orderDTO' is not null or undefined
      assertParamExists("memberCompassOrderProtoPost", "orderDTO", orderDTO);
      const localVarPath = `/member/compass-order/proto`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        orderDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns orders for this person
     * @param {OrderStateNew} [status] Order Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrdersGet: (
      status?: OrderStateNew,
      page?: number,
      pageSize?: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/member/compass-orders`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }
      if (status !== undefined) {
        localVarQueryParameter["status"] = status;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Applies discounts to open order based on supplied activation code
     * @param {string} code The discount code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberOrdersApplyDiscountByCodePost: (
      code: string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("memberOrdersApplyDiscountByCodePost", "code", code);
      const localVarPath = `/member/orders/applyDiscountByCode`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (code !== undefined) {
        localVarQueryParameter["code"] = code;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Cancels current person order, deleting if possible
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberOrdersCancelPost: (
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/member/orders/cancel`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets required agreements for current open order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberOrdersRequiredAgreementsGet: (
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/member/orders/requiredAgreements`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Polls order
     * @param {number} id The order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersIdPollPost: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("ordersIdPollPost", "id", id);
      const localVarPath = `/orders/{id}/poll`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets an existing order by id
     * @param {number} id The order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCompassOrderIdGet: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("staffCompassOrderIdGet", "id", id);
      const localVarPath = `/staff/compass-order/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates or inserts order and subobjects into the database for further use in the order system
     * @param {OrderDTO} orderDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCompassOrderPost: (
      orderDTO: OrderDTOTrackedI,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'orderDTO' is not null or undefined
      assertParamExists("staffCompassOrderPost", "orderDTO", orderDTO);
      const localVarPath = `/staff/compass-order`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        orderDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns orders for this person
     * @param {number} [personId] The personId of the order owner
     * @param {OrderStateNew} [status] Order Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCompassOrdersGet: (
      personId?: number,
      status?: OrderStateNew,
      page?: number,
      pageSize?: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/compass-orders`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }
      if (personId !== undefined) {
        localVarQueryParameter["personId"] = personId;
      }

      if (status !== undefined) {
        localVarQueryParameter["status"] = status;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Prints order receipt
     * @param {PrintOrderReceiptDTO} printOrderReceiptDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrderPrintReceiptPost: (
      printOrderReceiptDTO: PrintOrderReceiptDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'printOrderReceiptDTO' is not null or undefined
      assertParamExists(
        "staffOrderPrintReceiptPost",
        "printOrderReceiptDTO",
        printOrderReceiptDTO,
      );
      const localVarPath = `/staff/order/printReceipt`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        printOrderReceiptDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Cancels an order, deleting if possible
     * @param {number} id The order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrdersCancelIdPost: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("staffOrdersCancelIdPost", "id", id);
      const localVarPath = `/staff/orders/cancel/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Captures paid orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrdersCapturePaidPost: (
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/orders/capturePaid`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {FixLineItemRequestDTO} fixLineItemRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrdersFixLineItemPost: (
      fixLineItemRequestDTO: FixLineItemRequestDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'fixLineItemRequestDTO' is not null or undefined
      assertParamExists(
        "staffOrdersFixLineItemPost",
        "fixLineItemRequestDTO",
        fixLineItemRequestDTO,
      );
      const localVarPath = `/staff/orders/fixLineItem`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        fixLineItemRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type memberCompassOrderIdGetParams = { id: number };
export type memberCompassOrderOpenGetParams = {};
export type memberCompassOrderPostParams = { orderDTO: OrderDTOTrackedI };
export type memberCompassOrderProtoPostParams = { orderDTO: OrderDTOTrackedI };
export type memberCompassOrdersGetParams = {
  status?: OrderStateNew;
  page?: number;
  pageSize?: number;
};
export type memberOrdersApplyDiscountByCodePostParams = { code: string };
export type memberOrdersCancelPostParams = {};
export type memberOrdersRequiredAgreementsGetParams = {};
export type ordersIdPollPostParams = { id: number };
export type staffCompassOrderIdGetParams = { id: number };
export type staffCompassOrderPostParams = { orderDTO: OrderDTOTrackedI };
export type staffCompassOrdersGetParams = {
  personId?: number;
  status?: OrderStateNew;
  page?: number;
  pageSize?: number;
};
export type staffOrderPrintReceiptPostParams = {
  printOrderReceiptDTO: PrintOrderReceiptDTO;
};
export type staffOrdersCancelIdPostParams = { id: number };
export type staffOrdersCapturePaidPostParams = {};
export type staffOrdersFixLineItemPostParams = {
  fixLineItemRequestDTO: FixLineItemRequestDTO;
};

export const memberCompassOrderIdGetMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};
export const memberCompassOrderOpenGetMeta = {};
export const memberCompassOrderPostMeta = {
  orderDTO: propertyMeta("orderDTO", false, true, false, OrderDTOMeta),
};
export const memberCompassOrderProtoPostMeta = {
  orderDTO: propertyMeta("orderDTO", false, true, false, OrderDTOMeta),
};
export const memberCompassOrdersGetMeta = {
  status: propertyMeta("status", false, false, false, OrderStateNewMeta),
  page: propertyMeta("page", false, true, false, MetaTypesBase.number),
  pageSize: propertyMeta("pageSize", false, true, false, MetaTypesBase.number),
};
export const memberOrdersApplyDiscountByCodePostMeta = {
  code: propertyMeta("code", false, true, false, MetaTypesBase.string),
};
export const memberOrdersCancelPostMeta = {};
export const memberOrdersRequiredAgreementsGetMeta = {};
export const ordersIdPollPostMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};
export const staffCompassOrderIdGetMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};
export const staffCompassOrderPostMeta = {
  orderDTO: propertyMeta("orderDTO", false, true, false, OrderDTOMeta),
};
export const staffCompassOrdersGetMeta = {
  personId: propertyMeta("personId", false, false, false, MetaTypesBase.number),
  status: propertyMeta("status", false, false, false, OrderStateNewMeta),
  page: propertyMeta("page", false, true, false, MetaTypesBase.number),
  pageSize: propertyMeta("pageSize", false, true, false, MetaTypesBase.number),
};
export const staffOrderPrintReceiptPostMeta = {
  printOrderReceiptDTO: propertyMeta(
    "printOrderReceiptDTO",
    false,
    true,
    false,
    PrintOrderReceiptDTOMeta,
  ),
};
export const staffOrdersCancelIdPostMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};
export const staffOrdersCapturePaidPostMeta = {};
export const staffOrdersFixLineItemPostMeta = {
  fixLineItemRequestDTO: propertyMeta(
    "fixLineItemRequestDTO",
    false,
    true,
    false,
    FixLineItemRequestDTOMeta,
  ),
};

/**
 * CompassOrderApi - functional programming interface
 * @export
 */
export const useCompassOrderApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    CompassOrderApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     * Returns the current order this person has open
     * @param {number} id The order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderIdGetRaw(
      props: memberCompassOrderIdGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCompassOrderIdGet(props.id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberCompassOrderIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns the current order this person has open
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderOpenGetRaw(
      props: memberCompassOrderOpenGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCompassOrderOpenGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberCompassOrderOpenGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Updates or inserts order and subobjects into the database for further use in the order system
     * @param {OrderDTO} orderDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderPostRaw(
      props: memberCompassOrderPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCompassOrderPost(
          props.orderDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberCompassOrderPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns an order with calculated values without creating anything in the database
     * @param {OrderDTO} orderDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderProtoPostRaw(
      props: memberCompassOrderProtoPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCompassOrderProtoPost(
          props.orderDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberCompassOrderProtoPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns orders for this person
     * @param {OrderStateNew} [status] Order Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrdersGetRaw(
      props: memberCompassOrdersGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<OrderDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCompassOrdersGet(
          props.status,
          props.page,
          props.pageSize,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberCompassOrdersGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<OrderDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<OrderDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Applies discounts to open order based on supplied activation code
     * @param {string} code The discount code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberOrdersApplyDiscountByCodePostRaw(
      props: memberOrdersApplyDiscountByCodePostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberOrdersApplyDiscountByCodePost(
          props.code,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "CompassOrderApi.memberOrdersApplyDiscountByCodePost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Cancels current person order, deleting if possible
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberOrdersCancelPostRaw(
      props: memberOrdersCancelPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberOrdersCancelPost(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberOrdersCancelPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Gets required agreements for current open order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberOrdersRequiredAgreementsGetRaw(
      props: memberOrdersRequiredAgreementsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonAgreementsDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberOrdersRequiredAgreementsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "CompassOrderApi.memberOrdersRequiredAgreementsGet"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<PersonAgreementsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonAgreementsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Polls order
     * @param {number} id The order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersIdPollPostRaw(
      props: ordersIdPollPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderStateNew> {
      const localVarAxiosArgs = localVarAxiosParamCreator.ordersIdPollPost(
        props.id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.ordersIdPollPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderStateNew>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderStateNew", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets an existing order by id
     * @param {number} id The order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCompassOrderIdGetRaw(
      props: staffCompassOrderIdGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderWithDiscountsDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffCompassOrderIdGet(props.id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffCompassOrderIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderWithDiscountsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderWithDiscountsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Updates or inserts order and subobjects into the database for further use in the order system
     * @param {OrderDTO} orderDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCompassOrderPostRaw(
      props: staffCompassOrderPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderWithDiscountsDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffCompassOrderPost(
        props.orderDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffCompassOrderPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderWithDiscountsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderWithDiscountsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns orders for this person
     * @param {number} [personId] The personId of the order owner
     * @param {OrderStateNew} [status] Order Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCompassOrdersGetRaw(
      props: staffCompassOrdersGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<OrderDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffCompassOrdersGet(
        props.personId,
        props.status,
        props.page,
        props.pageSize,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffCompassOrdersGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<OrderDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<OrderDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Prints order receipt
     * @param {PrintOrderReceiptDTO} printOrderReceiptDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrderPrintReceiptPostRaw(
      props: staffOrderPrintReceiptPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffOrderPrintReceiptPost(
          props.printOrderReceiptDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffOrderPrintReceiptPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Cancels an order, deleting if possible
     * @param {number} id The order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrdersCancelIdPostRaw(
      props: staffOrdersCancelIdPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffOrdersCancelIdPost(props.id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffOrdersCancelIdPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Captures paid orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrdersCapturePaidPostRaw(
      props: staffOrdersCapturePaidPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      authStore.requireOneOfPermissions([{ domain: "admin", action: "ADMIN" }]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffOrdersCapturePaidPost(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffOrdersCapturePaidPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     *
     * @param {FixLineItemRequestDTO} fixLineItemRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrdersFixLineItemPostRaw(
      props: staffOrdersFixLineItemPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FixLineItemResponseDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffOrdersFixLineItemPost(
          props.fixLineItemRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffOrdersFixLineItemPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<FixLineItemResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("FixLineItemResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     * Returns the current order this person has open
     * @param {number} id The order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderIdGet(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCompassOrderIdGet(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberCompassOrderIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns the current order this person has open
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderOpenGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCompassOrderOpenGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberCompassOrderOpenGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Updates or inserts order and subobjects into the database for further use in the order system
     * @param {OrderDTO} orderDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderPost(
      orderDTO: OrderDTOTrackedI,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCompassOrderPost(orderDTO, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberCompassOrderPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns an order with calculated values without creating anything in the database
     * @param {OrderDTO} orderDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrderProtoPost(
      orderDTO: OrderDTOTrackedI,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCompassOrderProtoPost(
          orderDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberCompassOrderProtoPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns orders for this person
     * @param {OrderStateNew} [status] Order Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCompassOrdersGet(
      status?: OrderStateNew,
      page?: number,
      pageSize?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<OrderDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCompassOrdersGet(
          status,
          page,
          pageSize,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberCompassOrdersGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<OrderDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<OrderDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Applies discounts to open order based on supplied activation code
     * @param {string} code The discount code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberOrdersApplyDiscountByCodePost(
      code: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberOrdersApplyDiscountByCodePost(
          code,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "CompassOrderApi.memberOrdersApplyDiscountByCodePost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Cancels current person order, deleting if possible
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberOrdersCancelPost(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberOrdersCancelPost(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.memberOrdersCancelPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Gets required agreements for current open order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberOrdersRequiredAgreementsGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonAgreementsDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberOrdersRequiredAgreementsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "CompassOrderApi.memberOrdersRequiredAgreementsGet"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<PersonAgreementsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonAgreementsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Polls order
     * @param {number} id The order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersIdPollPost(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderStateNew> {
      const localVarAxiosArgs = localVarAxiosParamCreator.ordersIdPollPost(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.ordersIdPollPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderStateNew>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderStateNew", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets an existing order by id
     * @param {number} id The order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCompassOrderIdGet(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderWithDiscountsDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffCompassOrderIdGet(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffCompassOrderIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderWithDiscountsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderWithDiscountsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Updates or inserts order and subobjects into the database for further use in the order system
     * @param {OrderDTO} orderDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCompassOrderPost(
      orderDTO: OrderDTOTrackedI,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderWithDiscountsDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffCompassOrderPost(
        orderDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffCompassOrderPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderWithDiscountsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderWithDiscountsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns orders for this person
     * @param {number} [personId] The personId of the order owner
     * @param {OrderStateNew} [status] Order Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCompassOrdersGet(
      personId?: number,
      status?: OrderStateNew,
      page?: number,
      pageSize?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<OrderDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffCompassOrdersGet(
        personId,
        status,
        page,
        pageSize,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffCompassOrdersGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<OrderDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<OrderDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Prints order receipt
     * @param {PrintOrderReceiptDTO} printOrderReceiptDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrderPrintReceiptPost(
      printOrderReceiptDTO: PrintOrderReceiptDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffOrderPrintReceiptPost(
          printOrderReceiptDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffOrderPrintReceiptPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Cancels an order, deleting if possible
     * @param {number} id The order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrdersCancelIdPost(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffOrdersCancelIdPost(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffOrdersCancelIdPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Captures paid orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrdersCapturePaidPost(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      authStore.requireOneOfPermissions([{ domain: "admin", action: "ADMIN" }]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffOrdersCapturePaidPost(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffOrdersCapturePaidPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     *
     * @param {FixLineItemRequestDTO} fixLineItemRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffOrdersFixLineItemPost(
      fixLineItemRequestDTO: FixLineItemRequestDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FixLineItemResponseDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffOrdersFixLineItemPost(
          fixLineItemRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CompassOrderApi.staffOrdersFixLineItemPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<FixLineItemResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("FixLineItemResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * CompassOrderApi - interface
 * @export
 * @interface CompassOrderApi
 */
export interface CompassOrderApiInterface {
  /**
   * Returns the current order this person has open
   * @param {number} id The order id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  memberCompassOrderIdGet(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderDTO>;

  /**
   * Returns the current order this person has open
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  memberCompassOrderOpenGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderDTO>;

  /**
   * Updates or inserts order and subobjects into the database for further use in the order system
   * @param {OrderDTO} orderDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  memberCompassOrderPost(
    orderDTO: OrderDTOTrackedI,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderDTO>;

  /**
   * Returns an order with calculated values without creating anything in the database
   * @param {OrderDTO} orderDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  memberCompassOrderProtoPost(
    orderDTO: OrderDTOTrackedI,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderDTO>;

  /**
   * Returns orders for this person
   * @param {OrderStateNew} [status] Order Status
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  memberCompassOrdersGet(
    status?: OrderStateNew,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<OrderDTO>>;

  /**
   * Applies discounts to open order based on supplied activation code
   * @param {string} code The discount code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  memberOrdersApplyDiscountByCodePost(
    code: string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderDTO>;

  /**
   * Cancels current person order, deleting if possible
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  memberOrdersCancelPost(options?: RawAxiosRequestConfig): AxiosPromise<void>;

  /**
   * Gets required agreements for current open order
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  memberOrdersRequiredAgreementsGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonAgreementsDTO>;

  /**
   * Polls order
   * @param {number} id The order ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  ordersIdPollPost(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderStateNew>;

  /**
   * Gets an existing order by id
   * @param {number} id The order id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  staffCompassOrderIdGet(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderWithDiscountsDTO>;

  /**
   * Updates or inserts order and subobjects into the database for further use in the order system
   * @param {OrderDTO} orderDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  staffCompassOrderPost(
    orderDTO: OrderDTOTrackedI,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderWithDiscountsDTO>;

  /**
   * Returns orders for this person
   * @param {number} [personId] The personId of the order owner
   * @param {OrderStateNew} [status] Order Status
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  staffCompassOrdersGet(
    personId?: number,
    status?: OrderStateNew,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<OrderDTO>>;

  /**
   * Prints order receipt
   * @param {PrintOrderReceiptDTO} printOrderReceiptDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  staffOrderPrintReceiptPost(
    printOrderReceiptDTO: PrintOrderReceiptDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Cancels an order, deleting if possible
   * @param {number} id The order ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  staffOrdersCancelIdPost(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Captures paid orders
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  staffOrdersCapturePaidPost(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   *
   * @param {FixLineItemRequestDTO} fixLineItemRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompassOrderApiInterface
   */
  staffOrdersFixLineItemPost(
    fixLineItemRequestDTO: FixLineItemRequestDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<FixLineItemResponseDTO>;
}
